import { Component, effect, inject, viewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { NumericUpDownCustomization } from './numericupdown-edit';

/******************************
 *
 *       NUMERICUPDOWNVALUE
 *
 *******************************/
@Component({
  selector: 'lib-numericupdown-compiled',
  imports: [ReactiveFormsModule, InputNumberModule],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div class="p-fluid flex w-full flex-col gap-2">
        <label for="data" class="whitespace-normal text-justify">{{
          widget.customization.description
        }}</label>
        <p-inputNumber
          [autofocus]="false"
          id="data"
          [formControl]="formControl"
          (onKeyDown)="onKeyDown($event)"
          class="w-full rounded-md bg-white"
          decrementButtonClass="b-0 m-0 p-0 bg-accent"
          incrementButtonClass="b-0 m-0 p-0 bg-accent"
          #number
        />
      </div>
    }
  `,
  styleUrls: ['../style.css'],
  providers: [],
})
export class NumericUpDownCompiledComponent {
  protected widgetService = inject(
    CompilingWidgetService<NumericUpDownCustomization>,
  );

  number = viewChild<InputNumber>('number');

  constructor() {
    effect(() => {
      const number = this.number();
      if (!number) return;

      const widget = this.widgetService.widget();
      if (!widget) return;

      switch (widget.customization.topology) {
        case 0:
          number.showButtons = false;
          break;
        case 1:
          number.showButtons = true;
          break;
      }

      number.max = widget.customization.max;
      number.min = widget.customization.min;
      number.step = widget.customization.step;
    });
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
